// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fm-friend-list {
    margin-bottom: 20px;
}

.fm-friend-entry {
    align-items: center;
    background-color: #fafafa;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 10px;
    padding: 16px;
}

.fm-friend-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.fm-friend-info a {
    overflow-wrap: anywhere;
}

.fm-friend-info small {
    color: #666;
}

.fm-add-form .group {
    margin-bottom: 12px;
}

.fm-channel-suggestion {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.fm-channel-suggestion span {
    color: #666;
    font-size: 0.85em;
}

@media (max-width: 640px) {
    .fm-friend-entry {
        align-items: stretch;
        flex-direction: column;
    }

    .fm-friend-entry .button {
        align-self: flex-start;
    }
}

[data-theme="dark"] .fm-friend-entry {
    border-color: #3a463e;
    background-color: #1c2620;
}

[data-theme="dark"] .fm-friend-info small {
    color: #9fb0a6;
}

[data-theme="dark"] .fm-channel-suggestion span {
    color: #9fb0a6;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/FriendsManager.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".fm-friend-list {\n    margin-bottom: 20px;\n}\n\n.fm-friend-entry {\n    align-items: center;\n    background-color: #fafafa;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 10px;\n    padding: 16px;\n}\n\n.fm-friend-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.fm-friend-info a {\n    overflow-wrap: anywhere;\n}\n\n.fm-friend-info small {\n    color: #666;\n}\n\n.fm-add-form .group {\n    margin-bottom: 12px;\n}\n\n.fm-channel-suggestion {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.fm-channel-suggestion span {\n    color: #666;\n    font-size: 0.85em;\n}\n\n@media (max-width: 640px) {\n    .fm-friend-entry {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .fm-friend-entry .button {\n        align-self: flex-start;\n    }\n}\n\n[data-theme=\"dark\"] .fm-friend-entry {\n    border-color: #3a463e;\n    background-color: #1c2620;\n}\n\n[data-theme=\"dark\"] .fm-friend-info small {\n    color: #9fb0a6;\n}\n\n[data-theme=\"dark\"] .fm-channel-suggestion span {\n    color: #9fb0a6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
